import { render, staticRenderFns } from "./FilterCentro.vue?vue&type=template&id=8c4e12ee"
import script from "./FilterCentro.vue?vue&type=script&lang=js"
export * from "./FilterCentro.vue?vue&type=script&lang=js"
import style0 from "./FilterCentro.vue?vue&type=style&index=0&id=8c4e12ee&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports